import React from "react";
import { Box, Heading, Image } from "@salesforce/retail-react-app/app/components/shared/ui";
import { useParams } from 'react-router-dom';
import Seo from "@salesforce/retail-react-app/app/components/seo";
import useFetchLibraryFolders from "../../hooks/useFetchLibrary";
import { BlogDetailsStyle } from "./styles";
import { formattedDate } from "../../utills/helperServices";
import TagsLink from "./TagsLink";
import Link from "@salesforce/retail-react-app/app/components/link";
import LoadingSpinner from "../../components/loading-spinner";
import { useIntl } from "react-intl";

const BlogDetail = () => {
    const { contentID } = useParams();
    const intl = useIntl()
    //'national-day-of-the-cowgirl' clientID

    const { data, loading, error } = useFetchLibraryFolders(`content/${contentID}`);

    if (loading && !error) {
        return <LoadingSpinner />;
    }

    return (<Box sx={BlogDetailsStyle}>

        <Seo
            title={data?.page_title}
            description={data.page_description}
            keywords={data.page_keywords}
        />
        <Box className="blog-container" >
            {data?.c_heroImage && <Box className="blog-name">
                <Link to="/cavenders-ranch/">
                    <Image src={data.c_heroImage} alt={intl.formatMessage({
                        id: 'blog.banner.image_alt_message',
                        defaultMessage: 'Cavenders Ranch Blog'
                    })} />
                </Link>
            </Box>}
            <Box className="blog-content-asset">
                <Box as="section">
                    <Heading as='h3'>{data.name}</Heading>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box as='p'>{formattedDate(data.c_BlogLinkArticleDate)}</Box>
                        <TagsLink data={data} />
                    </Box>
                </Box>
                <Box dangerouslySetInnerHTML={{ __html: data?.c_body }}></Box>
                <TagsLink tags data={data} />
            </Box>

        </Box>

    </Box>)
};

export default BlogDetail;